<template>
  <v-dialog
    v-model="dialog"
    max-width="650"
    persistent
    scrollable
    :fullscreen="isMobile()"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="info"
        rounded
        :depressed="isMobile()"
        :text="!isMobile()"
        :disabled="itemJaAdd()"
        height="33"
        v-on="on"
        v-bind="attrs"
        :block="isMobile()"
      >
        <v-icon left>mdi-cart-check</v-icon> Selecionar
      </v-btn>
    </template>
    <v-card v-if="produtoSelecionado" :tile="isMobile()">
      <v-card-title
        class="font-weight-bold"
        :class="{ 'primary white--text': isMobile() }"
      >
        {{ produto.produto }}
      </v-card-title>
      <v-card-subtitle class="title">
        <v-chip class="font-weight-bold mt-2">{{ produto.emb }}</v-chip>
      </v-card-subtitle>
      <v-card-text>
        <v-form ref="form" class="mt-4">
          <v-row>
            <v-col xl="4" lg="4" md="4" cols="12">
              <v-text-field
                label="Preço de lista"
                class="title font-weight-bold"
                :value="formatarMoeda(produto.precolista, 4)"
                outlined
                disabled
                hide-details=""
              ></v-text-field>
            </v-col>
            <v-col xl="4" lg="4" md="4" cols="12">
              <v-text-field
                label="Quantidade"
                class="title"
                v-model="quantidade"
                autofocus
                v-mask="'######'"
                :rules="rulesQtde()"
                :messages="msgQtdeMinMax()"
                outlined
              ></v-text-field>
            </v-col>
            <v-col xl="4" lg="4" md="4" cols="12">
              <v-text-field
                label="% Desconto"
                class="title"
                v-model="percdesconto"
                outlined
                v-mask="maskDecimal"
                :rules="rulesPercDesconto()"
                append-icon=""
                :messages="msgDesconto()"
                :disabled="getTipoPedidoSelec().remessa"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row dense class="mt-2">
            <v-col cols="12">
              <v-card flat rounded="lg" class="grey lighten-4">
                <v-card-title class="subtitle-1 font-weight-bold"
                  >Valores calculados <v-spacer></v-spacer>
                  <detalhes-calculo
                    v-if="
                      usuarioLogado.colaborador_interno &&
                      produtoSelecionado.qtde > 0
                    "
                  />
                </v-card-title>
                <v-card-text>
                  <v-row dense>
                    <v-col cols="8" class="subtitle-2"> Valor desconto </v-col>
                    <v-col cols="4">
                      <span :class="classCamposTotais()">{{
                        formatarMoeda(produtoSelecionado.valordesconto)
                      }}</span>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="8" class="subtitle-2"> Valor frete </v-col>
                    <v-col cols="4">
                      <span :class="classCamposTotais()">{{
                        formatarMoeda(
                          produtoSelecionado.valorliqfrete > 0
                            ? produtoSelecionado.valorliqfrete
                            : produtoSelecionado.valorfrete
                        )
                      }}</span>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="8" class="subtitle-2"> Valor unitário </v-col>
                    <v-col cols="4">
                      <span :class="classCamposTotais()">{{
                        formatarMoeda(produtoSelecionado.vlrunitcomfrete, 4)
                      }}</span>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="8" class="subtitle-2">
                      Valor total do produto
                    </v-col>
                    <v-col cols="4">
                      <span :class="classCamposTotais()">{{
                        formatarMoeda(produtoSelecionado.valortotalitem)
                      }}</span>
                    </v-col>
                  </v-row>
                  <template
                    v-if="
                      getCondicaoSelecionada().cartao &&
                      novopedido.cartaoSelecionado > 0
                    "
                  >
                    <v-row dense>
                      <v-col cols="8" class="subtitle-2">
                        Cartão selecionado
                      </v-col>
                      <v-col cols="4">
                        <span
                          :class="classCamposTotais()"
                          style="text-align: end"
                          >{{
                            config.cartoes.find(
                              (c) => c.cod == novopedido.cartaoSelecionado
                            ).cartao
                          }}
                          ({{ getTxJuros() }}%)</span
                        >
                      </v-col>
                    </v-row>
                  </template>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-btn
            depressed
            color="success"
            rounded
            block
            @click="addProduto()"
            class="mt-5"
            >Confirmar</v-btn
          >
        </v-form>
      </v-card-text>
      <v-card-actions :class="{ 'pa-0': isMobile() }">
        <v-spacer></v-spacer>
        <v-btn
          @click="dialog = false"
          rounded
          text
          :tile="isMobile()"
          :block="isMobile()"
          :class="{ 'grey white--text': isMobile() }"
          :height="isMobile() ? 50 : 40"
          >Fechar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatMoeda, formatPercentual, formatarNumeroDec } from "@/global";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import DetalhesCalculo from "../DetalhesCalculo.vue";
export default {
  components: { DetalhesCalculo },
  props: {
    produto: Object,
  },
  watch: {
    dialog: function (open) {
      if (open) {
        this.setProdutoSelecionado(this.produto);
        this.quantidade = "";
        this.percdesconto = 0;
      }
    },
    quantidade: function () {
      this.setarValores();
    },
    percdesconto: function () {
      this.setarValores();
    },
  },
  computed: {
    ...mapState("pedidos", [
      "novopedido",
      "produtos",
      "produtoSelecionado",
      "config",
    ]),
    ...mapState("usuario", ["usuarioLogado"]),
  },
  data: () => ({
    dialog: false,
    quantidade: "",
    percdesconto: 0,
    maskDecimal: createNumberMask({
      prefix: "",
      includeThousandsSeparator: false,
      decimalSymbol: ",",
      allowLeadingZeroes: true,
      allowDecimal: true,
      integerLimit: 2,
    }),
  }),
  methods: {
    ...mapActions("pedidos", ["calcularProduto", "recalcularFrete"]),
    ...mapMutations("pedidos", ["setDialogProdutos", "setProdutoSelecionado"]),
    ...mapGetters("pedidos", [
      "getCondicaoSelecionada",
      "getTipoPedidoSelec",
      "getTxJuros",
    ]),
    classCamposTotais() {
      return "float-right subtitle-1 font-weight-bold black--text";
    },
    isMobile() {
      return this.$mq == "sm";
    },
    addProduto() {
      if (this.$refs.form.validate()) {
        this.novopedido.produtos.push(this.produtoSelecionado);
        this.recalcularFrete();
        this.dialog = false;
        this.setDialogProdutos(false);
      }
    },
    itemJaAdd() {
      return (
        this.novopedido.produtos.filter((p) => p.id == this.produto.id).length >
        0
      );
    },
    formatarMoeda(value, numDec) {
      return formatMoeda(value, numDec);
    },
    msgDesconto() {
      return `${
        this.produto.mindesconto > 0
          ? `Mín desconto: ${formatPercentual(this.produto.mindesconto)} | `
          : ""
      }Máx desconto: ${formatPercentual(this.produto.maxdesconto)}`;
    },
    msgQtdeMinMax() {
      if (this.getTipoPedidoSelec().remessa) {
        return (
          `Disp. p/ retirada: ${this.produto.disponivelretirada} ` +
          (this.produto.qtdeemb == 1 ? "Kgs (Saldo Futura - Pedido)" : "")
        );
      }

      var msgQtde = "";
      if (this.produto.qtdemin > 1)
        msgQtde = `Qtde mín: ${this.produto.qtdemin} ${this.produto.emb}`;

      if (this.produto.qtdemax > 1)
        msgQtde += ` | Qtde máx: ${this.produto.qtdemax} ${this.produto.emb}`;

      if (msgQtde != "") return msgQtde;

      return "";
    },
    rulesPercDesconto() {
      //if (this.percdesconto != ""){}
      return [
        (v) =>
          (v != "" &&
            v.replace(",", ".") <= this.produto.maxdesconto &&
            v.replace(",", ".") >= this.produto.mindesconto) ||
          this.msgDesconto(),
      ];

      //return [];
    },
    rulesQtde() {
      if (this.getTipoPedidoSelec().remessa) {
        return [
          (v) =>
            (!!v &&
              v <= this.produto.disponivelretirada &&
              v >= this.produto.qtdemin &&
              v <= this.produto.qtdemax) ||
            "Informe corretamente a quantidade",
        ];
      }

      var rules = [];
      rules.push(
        (v) =>
          (!!v && v >= this.produto.qtdemin) ||
          "Informe corretamente a quantidade"
      );

      if (this.produto.qtdemax > 0) {
        rules.push(
          (v) =>
            (!!v && v <= this.produto.qtdemax) ||
            "Informe corretamente a quantidade"
        );
      }

      return rules;
    },
    setarValores() {
      this.produtoSelecionado.qtde = parseInt(this.quantidade);
      if (isNaN(this.produtoSelecionado.qtde)) {
        this.produtoSelecionado.qtde = 0;
      }
      this.produtoSelecionado.percdesconto = parseFloat(
        formatarNumeroDec(this.percdesconto)
      );

      this.calcularProduto();
    },
  },
};
</script>

<style>
</style>